<template>
    <div class="leads-biodata">
        <!-- <ScheduleMeetingModal :show_schedule_meeting.sync="modals.show_schedule_meeting" :leadData="lead" @closeMeetingModal="closeMeetingModal" /> -->
        <!-- <CallLogForm :log_call.sync="modals.log_call" :leadData="leadData" @closeLogCallModal="closeLogCallModal" /> -->
        <b-card no-body>
            <!-- HEADER -->
            <b-card-header class="border-0 pt-3 px-3 pb-0">
                <b-row align-v="center">
                    <b-col cols="10" class="d-flex align-items-center">
                        <h3 class="mb-0">
                            {{ lead.name | formatUserName }} 
                        </h3>
                        <!-- <p class="mx-2 text-xs" :class="getClockIconColor(lead.tracking_color)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512"><path fill="currentColor" d="M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                            {{ lead.created_at | dateDiffDays }} days
                        </p> -->
                    </b-col>
                    <b-col cols="2">
                        <el-button @click="$refs.drawer_edit_lead_profile.viewEditProfile()" class="float-right py-0" type="text">Edit</el-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p class="text-xs mb-2" :class="getClockIconColor(lead.tracking_color)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512"><path fill="currentColor" d="M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                            {{ lead.time_difference }}
                        </p>
                    </b-col>
                </b-row>
            </b-card-header>
            <!-- BODY -->
            <b-container>
                <b-row class="d-flex align-items-center contact-items">
                    <b-col cols="9" class="d-flex align-items-center">
                        <div class="my-2" v-if="auth_user.subscription.privileges.scpk_crm_chat_massage">
                        <MessagingBoxButton :type="'lead'" :profile="lead" />		
												</div>
                        <!-- Phone Icon -->
                        <!-- <svg xmlns="http://www.w3.org/2000/svg" class="contact-icons border border-primary rounded-circle mx-1 cursor-pointer" width="36" height="36" viewBox="0 0 24 24" @click="openLogCallModal(lead)"><path fill="#5e72e4" d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02c-.37-1.11-.56-2.3-.56-3.53c0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/></svg> -->
                        <!-- Mail Icon -->
                        <!-- <svg v-b-tooltip.hover="lead.email ? lead.email : 'N/A'" xmlns="http://www.w3.org/2000/svg" class="contact-icons border border-primary rounded-circle mx-1" width="36" height="36" viewBox="0 0 24 24"><path fill="#5e72e4" d="M22 4H2v16h20V4zm-2 4l-8 5l-8-5V6l8 5l8-5v2z"/></svg> -->
                        <!-- Calendar Icon -->
                        <!-- <svg xmlns="http://www.w3.org/2000/svg" class="contact-icons border border-primary rounded-circle mx-1 cursor-pointer" width="36" height="36" viewBox="0 0 24 24" @click="openMeetingModal"><path fill="#5e72e4" d="M11 14v-2h2v2h-2Zm-4 0v-2h2v2H7Zm8 0v-2h2v2h-2Zm-4 4v-2h2v2h-2Zm-4 0v-2h2v2H7Zm8 0v-2h2v2h-2ZM3 22V4h3V2h2v2h8V2h2v2h3v18H3Zm2-2h14V10H5v10ZM5 8h14V6H5v2Zm0 0V6v2Z"/></svg> -->
                    </b-col>
                    <b-col cols="3" class="text-right">
                        <b-button 
                            variant="outline-success" 
                            class="py-1 px-2" 
                            @click="syncCustomerToLeadDetail" 
                            v-b-tooltip.hover="'Sync from Customer'" 
                            v-if="lead.customer"
                            :disabled="is_loading_sync"
                    >
                            <b-icon icon="arrow-clockwise"></b-icon>
                        </b-button>
                    </b-col>
                </b-row>
                <!-- <b-row class="align-items-center status mb-3">
                    <b-col cols="6" class="pr-1">
                        <div class="border rounded p-2">
                            <span class="mb-0 text-muted">Main Status</span><br>
                            <el-select
                                v-model="main_status_id"
                                value-key="status_id"
                                filterable
                                size="mini"
								@change="_gNotif.notifySuccess('<b>Please select the sub status also')"
                                :disabled="true"
                                ><el-option
                                v-for="status in main_statuses"
                                :key="status.status_id"
                                :label="status.status"
                                :value="status.status_id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </b-col>
                    <b-col cols="6" class="pl-1">
                        <div class="border rounded p-2">
                            <span class="mb-0 text-muted">Sub Status</span><br>
                            <el-select
                                v-model="sub_status_id"
                                value-key="status_id"
                                filterable
                                size="mini"
                                :loading="loading"
                                @change="updateStatus($event)"
                                ><el-option
                                v-for="status in sub_statuses"
                                :key="status.status_id"
                                :label="status.status"
                                :value="status.status_id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </b-col>
                </b-row> -->
                <b-row class="align-items-center status mb-3">
                    <b-col cols="6" class="pr-1">
                        <div class="border rounded p-2">
                            <span class="mb-0 text-muted">Main Status</span><br>
                            <el-select
                                v-model="main_status_id"
                                value-key="status_id"
                                filterable
                                size="mini"
                                :disabled="!can_update_status"
																@change="_gNotif.notifySuccess('<b>Please select the sub status also')">
																<el-option
																	v-for="status in main_statuses"
																	:key="status.status_id"
																	:label="status.status"
																	:value="status.status_id"
																	>
																</el-option>
                            </el-select>
                        </div>
                    </b-col>
                    <b-col cols="6" class="pl-1">
                        <div class="border rounded p-2">
                            <span class="mb-0 text-muted">Sub Status</span><br>
                            <el-select
                                v-model="sub_status_id"
                                value-key="status_id"
                                filterable
                                size="mini"
                                @change="updateStatus($event)"
																:disabled="!can_update_status">
                                <el-option
                                v-for="status in sub_statuses"
                                :key="status.status_id"
                                :label="status.status"
                                :value="status.status_id">
                                </el-option>
                            </el-select>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group cols="12" md="6" class="mb-2">
                            <el-date-picker
														 v-model="lead.appointment_at" 
														 type="datetime"
														 format="yyyy-MM-dd HH:mm:ss"
                             value-format="yyyy-MM-dd HH:mm:ss"
														 placeholder="Select appointment time and date"
														 @blur="submitAppointment"
														>
                            </el-date-picker>
                        </b-form-group>
                            <b-button
															block
															variant="outline-primary"
															v-if="!isEmpty(lead.appointment_at)"
															@click="exportToGoogleCalendar(lead.appointment_at, lead.name)" 
															class="el-icon-date"
															style="cursor: pointer;">
															Export Appointment to Calendar
                            </b-button>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="12">
                        <div class="d-flex align-items-center mb-2">
                            <small class="pr-3 font-weight-bolder text-gray">ID</small>
                            <p>{{ lead.lead_id }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-icon icon="telephone-fill" class="mr-3" variant="gray"></b-icon>
                            <p>{{ lead.contact_no }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-icon icon="envelope-fill" class="mr-3" variant="gray"></b-icon>
                            <p>{{ lead.email || 'N/A' }}</p>
                        </div>
												<div class="d-flex align-items-center mb-2">
                            <p><strong>Category:</strong> {{ lead.category || 'N/A' }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2" v-if="checkAppCode('sas')">
                            <b-icon icon="currency-dollar" class="mr-3" variant="gray"></b-icon>
                            <p v-if="lead.income">RM{{ lead.income | moneyFormatter }}</p>
                            <p v-else>N/A</p>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <!-- FOOTER -->
            <b-card-footer class="p3" >
                <b-row class="d-flex justify-content-center">
                    <b-col cols="12" class="text-center" v-if="lead.customer">
                        <h4 class="text-primary">Customer ID {{ lead.customer.customer_id }}</h4>
                    </b-col>
                    <b-col cols="12" class="text-center">
                        <router-link :to="'/customerProfileDetails/'+lead.customer.customer_id" class="btn btn-primary" v-if="lead.customer">View Customer Profile</router-link>
                        <b-button block variant="outline-primary" v-else-if="lead.approval_json && lead.approval_json.approval_status == 'pending'" disabled>Pending Approval</b-button>
                        <b-button block variant="outline-primary" @click="modals.convert_to_customer = !modals.convert_to_customer" :disabled="checkLeadApproval()" v-else>Convert to Customer</b-button>
                    </b-col>
                </b-row>
            </b-card-footer>
        </b-card>

        

        <!-- Modal Create Customer -->
        <modal :show.sync="modals.convert_to_customer" modalClasses="medium-sized-modal modal-hide-footer">
            <h3 slot="header" class="mb-0 font-weight-500">Convert to Customer Profile</h3>

            <b-form role="form" @submit.prevent="convertToCustomer()">
                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Customer Name:">
                            <h4>{{ lead.name }}</h4>
                        </b-form-group>
                    </b-col>
                    
                    <b-col cols="8">
                        <b-form-group label="Is a Foreigner">
                            <el-radio-group v-model="form.is_foreigner">
                                <el-radio-button label="1">Yes</el-radio-button>
                                <el-radio-button label="0">No</el-radio-button>
                            </el-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8" v-if="form.is_foreigner == 0">
                        <b-form-group label="Customer NRIC:">
                            <b-form-input
                                v-model="form.nric"
                                maxlength="12"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8" v-if="form.is_foreigner == 1">
                        <b-form-group label="Passport">
                            <b-form-input
                            v-model="form.passport"
                            type="text"
                            placeholder="Enter passport"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8" v-if="form.is_foreigner == 1">
                        <b-form-group label="Foreign IC">
                            <b-form-input
                            v-model="form.foreign_ic"
                            type="text"
                            placeholder="Enter Foreign IC"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12">
                        <b-form-group label="Customer Email:">
                            <b-form-input
                            type="email"
                            v-model="form.email"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Company Name:">
                            <b-form-input
                            v-model="form.company_name"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Company Position:">
                            <b-form-input
                            v-model="form.company_position"
                            ></b-form-input>
												</b-form-group>
                    </b-col>
                    <!-- <b-col cols="12">
                        <b-form-group label="Category:">
                        <el-select v-model="form.category" placeholder="Select Category">
                            <el-option label="Full Loan Doc" value="Full Loan Doc"/>
                            <el-option label="Book an Unit" value="Book an Unit"/>
                        </el-select>
                        </b-form-group>
                    </b-col> -->
                </b-row>
                <b-row>
                    <b-col cols="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button type="submit" class="w-100" variant="primary" :disabled="is_loading_convert">Submit</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </modal>

        <!-- Drawer for Edit Profile -->
        <drawer-edit-lead-profile ref="drawer_edit_lead_profile" :lead="lead"></drawer-edit-lead-profile>
    </div>
</template>
<script>
    import { Button, Select, Option, Badge, Dropdown, DropdownItem, DropdownMenu, DatePicker, Radio, RadioGroup, RadioButton } from 'element-ui'
    import ScheduleMeetingModal from '@/views/Leads/LeadsProfile/LeadsModals/ScheduleMeetingModal'
    import {
        notifyFunctionMixin,
        helperFunctionMixin,
        axios,
        services,
        getHeader,
        swal,
    } from '@/assets/js/httpImports.js'
    import DrawerEditLeadProfile from '@/views/Leads/LeadsProfile/OffCanvasDetails/DrawerEditLeadProfile'
    import { useLeadStore } from '@/stores/leadStore'
    import { mapActions, mapState } from 'pinia'
        import CallLogForm from '@/views/Call/Modal/LogNewCallModal'
    import {isEqual} from 'lodash'
    import { useAuthStore } from '@/stores/authStore'
		import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
		import { useMessagingStore } from '@/stores/messagingStore'
    import { useNotificationStore } from '@/stores/notificationStore'

    export default {
        props: ['lead'],
        components: {
            DrawerEditLeadProfile,
            ScheduleMeetingModal,
            MessagingBoxButton,
            CallLogForm,
            [Radio.name]: Radio,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Button.name]: Button,
            [Select.name]: Select,
            [Option.name]: Option,
            [Badge.name]: Badge,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [DatePicker.name]: DatePicker,

        },
        mixins:[
            notifyFunctionMixin,
            helperFunctionMixin
        ],
        data() {
            return {
                main_status_id: null,
								sub_status_id: null,
                modals: {
                    convert_to_customer: false,
                    show_schedule_meeting: false,
                    log_call: false,
                },
                form: {
                    name: this.lead.name,
                    nric: '',
                    email: this.lead.email,
										category:'',
                    company_name: '',
                    company_position: '',
                    is_foreigner: 0,
                    passport: '',
                    foreign_ic: '',
                },
                tables: [],
                parentStatus: "",
                loading: false,
                options: [],
                leadData:{},
                lead_data: [],
                is_loading_sync:false,
                is_loading_convert:false,
            }
        },
        computed:{
            main_statuses(){
                return this.tables.length > 0 ? this.tables.filter(data => data.group == "main") : [];
            },
            sub_statuses(){
                let allSubStatuses = this.tables.length > 0 ? this.tables.filter(data => data.group == "sub") : [];
								let main_status_id = this.main_status_id;

								// return (!_gHlp.isEmpty(main_status_id)) ? allSubStatuses.filter(data => data.parent_id == main_status_id) : allSubStatuses;
								return allSubStatuses;
            },
						can_update_status(){
							let channelIds = _gAuth.activeCorpSettings('lead_reassign_only_channel_ids',[]);
							const allowSasOwnOnly = (_gAuth.isAppSas() && (channelIds.includes(this.lead.channel_id) || this.lead.message == 'lead-slack') && this.checkIsOwnLead(this.lead));
							const allowSasAdminOnly = (_gAuth.isAppSas() && !(channelIds.includes(this.lead.channel_id) || this.lead.message == 'lead-slack') && _gHlp.checkAccess(['role_admin','role_admin_support','role_super_admin', 'role_manager_admin']));
							
							return this.checkIsOwnLead(this.lead) || (_gAuth.activeCorpIsMultiAssignment() && !_gAuth.isAppSas()) || allowSasOwnOnly || allowSasAdminOnly
            },
            ...mapState(useLeadStore,['current_lead']),
            ...mapState(useAuthStore,['auth_user']),
        },
        watch:{
					current_lead:{
						handler(newVal, oldVal){
							if(!isEqual(newVal, oldVal)){
								this.lead = newVal
								this.form.email = newVal.email;
								this.injectTableDataStatus();
								this.getProfileListMessagesSummaries('lead',[newVal])
							}
						},
						immediate: true
					}
        },
        async created(){
            this.getLeadStatus();
						// this.injectTableDataStatus();
        },
        methods: {
		    	...mapActions(useAuthStore,['fetchUserInfo']),
          ...mapActions(useLeadStore,[
						'getLeadActivityLog', 
						'getLead', 
						'checkIsOwnLead',
						'getRealStatusSummary',
						'getRealAssignAt',
						'getRealMessageAt',
						'getRealMessageBundle',
						'getRealAppointmentAt'
					]),
					...mapActions(useMessagingStore, ['getProfileListMessagesSummaries']),
          ...mapActions(useNotificationStore, ['createNotification','fetchNotificationTemplate']),
					// getRealStatusSummary(lead){
					// 	const actvUser = _gAuth.activeUser();
					// 	const hasAssign = lead.lead_assignments.find(
					// 						item => item.user_id == actvUser.id
					// 				);
					// 	if(_gHlp.isEmpty(hasAssign)) return lead.status_detail;

					// 	return hasAssign.status_detail;
					// },
					// getRealAssignAt(lead){
					// 	const actvUser = _gAuth.activeUser();
					// 	const hasAssign = lead.lead_assignments.find(
					// 						item => item.user_id == actvUser.id
					// 				);
					// 	if(_gHlp.isEmpty(hasAssign)) return lead.reassignment_at;

					// 	return hasAssign.assign_at;
					// },
					// getRealMessageAt(lead){
					// 	const actvUser = _gAuth.activeUser();
					// 	const hasAssign = lead.lead_assignments.find(
					// 						item => item.user_id == actvUser.id
					// 				);
					// 	if(_gHlp.isEmpty(hasAssign)) return lead.last_message_at;

					// 	return hasAssign.last_message_at;
					// },
					// getRealMessageBundle(lead){
					// 	const actvUser = _gAuth.activeUser();
					// 	const hasAssign = lead.lead_assignments.find(
					// 						item => item.user_id == actvUser.id
					// 				);
					// 	if(_gHlp.isEmpty(hasAssign)) return lead.message_group_bundle_key;

					// 	return hasAssign.message_group_bundle_key;
					// },
					injectTableDataStatus(){
						if(_gHlp.isEmpty(this.lead)) return false;

						if(_gAuth.activeCorpIsMultiAssignment()){
							this.lead.status_detail = this.getRealStatusSummary(this.lead);
							this.lead.message_group_bundle_key = this.getRealMessageBundle(this.lead);
							this.lead.reassignment_at = this.getRealAssignAt(this.lead);
							this.lead.last_message_at = this.getRealMessageAt(this.lead);
							this.lead.appointment_at = this.getRealAppointmentAt(this.lead);
						}

						// console.log(this.lead);
						// console.log(this.lead.status_detail);
						//INIT STATUS
						if(!_gHlp.isEmpty(this.lead.status_detail.main)){
							this.main_status_id = this.lead.status_detail.main.status_id;
						}
						if(!_gHlp.isEmpty(this.lead.status_detail.sub)){
							this.sub_status_id = this.lead.status_detail.sub.status_id;
							if(_gHlp.isEmpty(this.main_status_id)){
								this.main_status_id = this.lead.status_detail.sub.parent_id;
							}
						}
					},
					  getLeadStatus(){
                axios.get(services.lookup + 'status', {headers: getHeader()})
                    .then(res => {
                        this.tables = res.data.data
                    })
                    .catch(e => {})
            },
            syncCustomerToLeadDetail(){
                this.is_loading_sync = true
                axios.get(services.lead + 'lead/' + this.$route.params.lead_id +'/lead.syncFromCustomer', {headers: getHeader()})
                    .then(res=>{
                        this.is_loading_sync = false
                        this.notifySuccess('<b>Lead:</b> - Successfully Sync from Customer.')
                        this.getLeadActivityLog(this.$route.params.lead_id)
                        this.getLead(this.$route.params.lead_id)
                    })
                    .catch(e=>{
                        this.is_loading_sync = false
                        this.errorFunction(e)
                    })
            },
            submitAppointment() {
								if (!this.sub_status_id) {
									this._gNotif.notifyError('Please select a "Sub Status" before setting an appointment');
									this.lead.appointment_at = null;
								} else {
                	this.update(this.lead.appointment_at);
                }
            },
            update(appointment_at) {
                this.is_loading = true;
                axios.put(
                services.lead + 'leads/' + this.$route.params.lead_id,
                { appointment_at: appointment_at },
                { headers: getHeader() }
                )
                .then(res => { 
                this.is_loading = false;
                this.notifySuccess('Lead - Successfully Updated.');
                this.getLead(this.$route.params.lead_id);
                })
                .catch(e => {
                this.is_loading = false;
                this.errorFunction(e);
                });
            },
            updateStatus(status_id){
							if(_gHlp.isEmpty(status_id)) return false;

                axios.put(services.lead + 'lead/' + this.$route.params.lead_id + '/status/' + status_id, {}, { headers: getHeader() })
                    .then(async res => {
                        this.getLeadActivityLog(this.$route.params.lead_id)

                        let sub_status = this.sub_statuses.find(sub => sub.status_id == status_id);
                        this.main_status_id = sub_status.parent_id;
												this.sub_status_id = sub_status.status_id;

                        this.notifySuccess('<b>Lead Status: ' + this.lead.name + '</b> - Successfully Updated.');
                        // EventBus.$emit('updatePaginate')
                        const notificationTemplate = await this.fetchNotificationTemplate('LEAD_STATUS_CHANGE')
                        if (notificationTemplate && notificationTemplate.is_active) { 

                        let message = notificationTemplate.notif_temp_message
                      
                        const recipients = notificationTemplate.notif_temp_receiver.split(',').map(id => parseInt(id.trim(), 10));
                        let contentNotification = {
                          noti_message: "Lead #"+ this.$route.params.lead_id +" : "+message+" status:  "+sub_status.status,
                          noti_url: window.location.origin + '/leadsListing',
                          microservice_code: 'lead',
                          noti_related_type: 'lead',
                          noti_related_id: this.$route.params.lead_id
                        }
                        for (const recipient of recipients) {
                          if (!isNaN(recipient)) { // Check if recipient is a valid integer
                            let notification = { ...contentNotification, noti_user_id: recipient };
                            
                            // let notification = { ...contentNotification, noti_user_id: recipients }

                            this.createNotification(notification)
                        }
                        }
                      }

                   })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            convertToCustomer(){
                this.is_loading_convert = true
                let formData = new FormData()
                formData.append('name', this.form.name)
                formData.append('is_foreigner', this.form.is_foreigner)
                formData.append('nric', this.form.nric)
                formData.append('passport', this.form.passport)
                formData.append('foreign_ic', this.form.foreign_ic)
								// formData.append('category', this.form.category)
                if(this.form.email){
                    formData.append('email', this.form.email)
                }
                if(this.form.company_name && this.form.company_position){
                    formData.append('company_name', this.form.company_name)
                    formData.append('company_position', this.form.company_position)
                }

                let checkApproval = this.auth_user.access_codes.includes('vps_approval__create')
                if(checkApproval) {
                    formData.append('need_approval', true)
                }
                axios.post(services.lead + 'lead/' + this.$route.params.lead_id + '/lead.convert_to_customer', formData, { headers: getHeader() })
                    .then(async res => {
                        this.resetFormToNull(this.form)
                        this.modals.convert_to_customer = false
                        if(!checkApproval) {
                            this.is_loading_convert = false
                            this.notifySuccess('<b>Lead : ' + this.lead.name + '</b> - Successfully Converted to Customer.')
                            this.$router.push('/customerProfileDetails/'+res.data.data.customer_id)
                        }
                        else {
                            await this.fetchUserInfo();
                            await this.getLead(this.$route.params.lead_id);
                            this.notifySuccess('<b>Lead : ' + this.lead.name + '</b> - Successfully Submitted for Approval.')
                        }
                    })
                    .catch(e => {
                        this.is_loading_convert = false
                        this.errorFunction(e)
                    })
            },
            // openMeetingModal() {
            //     this.modals.show_schedule_meeting = true;
            // },
            // closeMeetingModal(){
            //     this.modals.show_schedule_meeting = false;
            // },
            // openLogCallModal(leadData){
            //     this.leadData = leadData
            //     this.modals.log_call = true
            // },
            // closeLogCallModal(){
            //     this.modals.log_call = false
            // },
            getClockIconColor(tracking_color) {

                switch (tracking_color) {
                    case 'green':
                        return 'text-success'; // Change to green color class
                        break;
                    case 'yellow':
                        return 'text-warning'; // Change to yellow color class
                        break;
                    case 'red':
                        return 'text-danger'; // Change to red color class
                        break;
                    default:
                        return 'text-primary'; // Change to blue color class
                        break;
                }
            },
            checkLeadApproval() {
                if(this.lead.approval_json != null)
                {
                    if(this.lead.approval_json.approval_status == 'rejected')
                    {
                        return false;
                    }
                    return true;
                }
                return false;
            },
            exportToGoogleCalendar(appointmentAt, leadName) {
            // Check if appointmentAt is not empty
            if (!this.isEmpty(appointmentAt)) {
                // Format the appointment date for the Google Calendar link
                const formattedDate = this.formatGoogleCalendarDate(appointmentAt);
                // Create the Google Calendar link
                const googleCalendarLink = this.generateGoogleCalendarLink(formattedDate, leadName);
                // Open the link in a new tab
                window.open(googleCalendarLink, '_blank');
            }
        },

        formatGoogleCalendarDate(appointmentAt) {
            const date = new Date(appointmentAt);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');

            return `${year}${month}${day}T${hours}${minutes}${seconds}`;
        },

        generateGoogleCalendarLink(formattedDate, leadName) {
            // Generate Google Calendar link with necessary details
            const googleCalendarLink = `https://www.google.com/calendar/render?action=TEMPLATE&dates=${formattedDate}/${formattedDate}&text=${leadName}&details=Your%20appointment%20description%20goes%20here.&location=Appointment%20Location&sf=true&output=xml`;

            return googleCalendarLink;
        },
      }
    }
</script>